import { styled } from "@linaria/react"

import { Vertical } from "@/components/Flex.ts"
import { Heading2 } from "@/components/Heading/Heading.tsx"
import { useModel } from "@/hooks/useModel.ts"
import { useMyProfile } from "@/hooks/useProfile.ts"
import { useQueries, useRootContext } from "@/hooks/useRootContext.ts"
import { toProfileUsername } from "@/lib/std.ts"
import { SshKeysTabActions } from "@/routes/user/SshKeysTabContent.tsx"
import { SshKeysTabModel } from "@/routes/user/SshKeysTabModel.ts"
import * as textStyles from "@/styles/textStyles.ts"

export const SshKeysOnboarding = ({ onComplete, showHeading = true }: {
  onComplete: () => void
  showHeading?: boolean
}) => {
  const context = useRootContext()
  const myProfile = useMyProfile()
  const queries = useQueries()

  const model = useModel(() => {
    if (myProfile == null) return null
    return new SshKeysTabModel(context, queries, toProfileUsername(myProfile.username), onComplete)
  })

  if (myProfile == null || model == null) return null

  return (
    <Container>
      {showHeading && <Heading2>Get started by adding an SSH key</Heading2>}
      <div>
        To connect to the preview environment, generate a new SSH key by running the following command in the
        terminal:
      </div>
      <NewSshKeyCommand>ssh-keygen -t rsa -b 4096 -C "your@email.com"</NewSshKeyCommand>
      <SshKeysTabActions model={model} profile={toProfileUsername(myProfile.username)} addKeyButtonKind="primary" />
    </Container>
  )
}

const Container = styled(Vertical)`
  gap: 16px;

  button:focus-visible {
    outline: none;
  }
`

const NewSshKeyCommand = styled.pre`
  background: var(--background-color);
  border-radius: var(--border-radius-8);
  padding: 8px;

  ${textStyles.pre};
`
